<template>
    <div class="error-page d-flex align-items-center justify-content-center p-3">
        <error404 />
    </div>
</template>

<script>
import Error404 from '@/components/errors/404.vue';
export default {
    components: {
        Error404
    }
};
</script>
